import { Box } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Component } from "@outschool/ownership-areas";
import {
  ContinueWithApple,
  LoginUserFeedback,
  useAuthError,
} from "@outschool/ui-auth";
import _ from "lodash";
import React from "react";

import { APPLE_SIGNIN_CLIENT_ID } from "../../../../../shared/Env";
import type { CreateOrLoginError } from "../../../generated/graphql";
import {
  AppleLoginSuccessPayload,
  useLoginWithApple,
} from "../../../hooks/authentication";
import { useLearnerAuth } from "../../../providers/LearnerAuthProvider";

export default function ConnectApple() {
  const { learnerAuth, setSessionToken } = useLearnerAuth();
  const hasApple = React.useMemo(
    () => (learnerAuth ? _.keyBy(learnerAuth.providers)["Apple"] : false),
    [learnerAuth],
  );
  const [userError, setUserError] = React.useState<React.ReactNode>(null);
  const generateLoginError = useAuthError("Apple");
  const handleAuthError = React.useCallback(
    (
      error: unknown,
      message: React.ReactNode = "Sorry that didn't work, try again",
    ) => {
      OsPlatform.captureError(error, {
        tags: { component: Component.LearnerMode },
      });
      setUserError(message);
    },
    [],
  );

  const handleLoginSuccess = React.useCallback(
    ({ sessionToken, refreshToken }: AppleLoginSuccessPayload) => {
      setSessionToken({ sessionToken, refreshToken });
    },
    [setSessionToken],
  );

  const handleLoginError = React.useCallback(
    (error: CreateOrLoginError) => {
      const errorObject = new Error(error);
      handleAuthError(errorObject, generateLoginError(error));
    },
    [handleAuthError, generateLoginError],
  );

  const loginWithApple = useLoginWithApple(
    handleLoginSuccess,
    handleLoginError,
  );

  return (
    <Box
      sx={{
        marginBottom: "0.5em",
      }}
    >
      {hasApple ? (
        <Box>Your Apple account is linked and you may use it to log in.</Box>
      ) : (
        <Box>
          {userError && (
            <Box
              sx={{
                marginBottom: "0.5em",
              }}
            >
              <LoginUserFeedback
                userFeedbackMessage={userError}
                isError={true}
              />
            </Box>
          )}
          <ContinueWithApple
            isLearnerApp
            onSuccess={loginWithApple}
            onError={handleAuthError}
            trackingName="learner_login.learner_settings.connect_with_apple"
            clientId={APPLE_SIGNIN_CLIENT_ID!}
          />
        </Box>
      )}
    </Box>
  );
}
